import { AccountSetupRequest, AccountSetupResponse } from '../types';
import axiosInstance from './axiosInstance';

export async function setupPayouts(req: AccountSetupRequest) {
  const response = await axiosInstance.post('/payouts/setup', req);

  return response.data as AccountSetupResponse;
}
